import { apiAuth } from './index';

/**
 * Response: [{
 *  id: int
 *  isToday: bool
 *  dateTime: string(new Date())
 *  dayOfWeek: int
 *  dayOfMonth: int
 *  persianDate: string
 *  weekOfYear: int
 *  isHoliday: bool
 *  hasOrder: bool
 *  isEndOrderTime: bool
 *  creationDateTime: string(new Date())
 *  modificationDateTime: string
 * }]
 */
export const fetchCalendar = async (xDayAfter = 7) => {
	try {
		const { data } = await apiAuth.get(`/date/get?xDayAfter=${xDayAfter}`);
		return data;
	} catch (e) {
		throw e;
	}
};

export const fetchToday = async () => {
	try {
		const { data } = await fetchCalendar(1);
		return data?.length ? data[0] : null;
	} catch (e) {
		throw e;
	}
};
